import { useFormContext } from 'react-hook-form';

import { TiltakFormData } from './types';

export const useTiltakFormContext = () => {
  return useFormContext<TiltakFormData>();
};
